import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef, useCallback, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';
import 'regenerator-runtime/runtime';
import { useAsyncDebounce } from 'react-table';
import { ReactComponent as ForwardRef } from '../../../../../assets/icons/CloseSmall.svg.js';
import Input from '../../../../Input/Input.js';

const Root = styled(MuiBox) `
  width: 100%;
  position: relative;
  padding: ${({ theme }) => theme.spacing(1)};
`;
const _Input = styled(Input) `
  width: 100%;
`;
const ClearIcon = styled(ForwardRef) `
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);

  > path {
    fill: ${({ theme }) => theme.palette.primary.light};
  }

  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
`;
const InputField = (_a) => {
    var { onChange, type = 'text', value = '', placeholder = 'Filter...' } = _a, rest = __rest(_a, ["onChange", "type", "value", "placeholder"]);
    const [inputValue, setValue] = useState(value);
    const ref = useRef(false);
    const onIntervalChange = useAsyncDebounce((value) => onChange === null || onChange === void 0 ? void 0 : onChange(value), 200);
    const clearValue = useCallback(() => setValue(''), []);
    useEffect(() => {
        if (ref.current) {
            onIntervalChange(inputValue);
        }
        else {
            ref.current = true;
        }
    }, [onIntervalChange, inputValue]);
    const onChangeInternal = useCallback(e => setValue(e.target.value), []);
    return (jsxs(Root, Object.assign({}, rest, { children: [jsx(_Input, { "data-testid": "filter-input", value: inputValue, placeholder: placeholder, onChange: onChangeInternal, type: type }), value && jsx(ClearIcon, { onClick: clearValue })] })));
};

export { InputField as default };
//# sourceMappingURL=InputField.js.map
